module.exports = __webpack_public_path__ + "0c4322eaaa9e1abc36be31452ffe3131.png";